import React from "react";
import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";
import AppNavbar from "../components/home/Navbar";
import Footer from "../components/footer/Footer";
import "./styles/not-found.css";

// Shown for any address the site does not know. Private pages are only
// declared once signed in, so a visitor may land here from such a link too.
function NotFound() {
  const { isAuthenticated } = useSelector((state) => state.authUser);

  return (
    <>
      <Helmet>
        <title>Page introuvable - Platform98</title>
      </Helmet>
      <AppNavbar />

      <main className="not-found">
        <p className="not-found-code">404</p>
        <h1 className="not-found-title">
          Page <span>introuvable</span>
        </h1>
        <p className="not-found-lead">
          {isAuthenticated
            ? "Cette page n'existe pas ou n'est plus disponible."
            : "Cette page n'existe pas, ou elle n'est accessible qu'une fois connecté à votre compte."}
        </p>

        <div className="not-found-actions">
          <Link to="/" className="not-found-button is-primary">
            Retour à l'accueil <FiArrowRight aria-hidden="true" />
          </Link>
          {isAuthenticated ? (
            <Link to="/formalities" className="not-found-button">
              Voir les formalités
            </Link>
          ) : (
            <Link to="/login" className="not-found-button">
              Se connecter
            </Link>
          )}
        </div>
      </main>

      <Footer />
    </>
  );
}

export default NotFound;
